import styled from 'styled-components';

const CoursesContainer = styled.div`

`;

export {
  CoursesContainer
}